export type PaymentProvider = 'robokassa' | 'tribute'

export type PaymentStatus = 'pending' | 'success' | 'failed' | 'cancelled' | 'refunded'

export const FINAL_PAYMENT_STATUSES: ReadonlyArray<PaymentStatus> = [
  'success',
  'failed',
  'cancelled',
  'refunded',
]

export interface InvoiceResponse {
  payment_url: string
  tracking_uuid: string
}

export interface PaymentStatusResponse {
  tracking_uuid: string
  status: PaymentStatus
  provider: PaymentProvider
  amount: string
  user_currency: string | null
  paid_currency: string | null
  paid_timestamp: string | null
}

export interface PaymentMethodResponse {
  payment_method_id: number
  provider: PaymentProvider
  masked_card_number: string
  card_brand: string | null
  is_main: boolean
}

export interface PaymentMethodsResponse {
  methods: PaymentMethodResponse[]
}

/**
 * Платёж, блокирующий покупку подписки (автоплатёж в ожидании проведения).
 * UI важен сам факт наличия — типизируем только стабильные поля ответа.
 */
export interface BlockingSubscriptionPaymentResponse {
  tracking_uuid: string
  status: PaymentStatus
  provider: PaymentProvider
}

export interface BuySubscriptionPayload {
  subscription_info_id: number
  provider: PaymentProvider
  currency?: string
  save_card?: boolean
  payment_method_id?: number
}

export interface BuyCoursePayload {
  course_id: number
  provider: PaymentProvider
  currency?: string
  save_card?: boolean
  payment_method_id?: number
}

export interface AttachCardPayload {
  provider: PaymentProvider
}
